import * as React from "react";
import DashboardInput, {
  type DashboardInputProps,
} from "@/ReactInit/Scripts/DashboardPage/components/DashboardInput";
import {cn} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

interface DashboardInputGroupProps {
  inputs: DashboardInputProps[];
  grids?: "default" | "1" | "2" | "3" | "4";
}

const DashboardInputGroup: React.FC<DashboardInputGroupProps> = ({inputs, grids = "default"}) => {
  const gridSwitch = () => {
    switch (grids) {
      case "1":
        return "grid-cols-1";
      case "2":
        return "grid-cols-1 tablet:grid-cols-2";
      case "3":
        return "grid-cols-1 tablet:grid-cols-3";
      case "4":
        return "grid-cols-1 tablet:grid-cols-4";
      case "default":
      default:
        return "grid-cols-1 tablet:grid-cols-2";
    }
  }

  return (
    <div className={cn("grid gap-6", gridSwitch())}>
      {inputs.map((input) => (
        <DashboardInput key={input.id} {...input} />
      ))}
    </div>
  );
};

export default DashboardInputGroup;
